import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams, useLocation } from 'react-router-dom'; 
import Cookies from 'universal-cookie';


const CustomerLogin = () => {
  const navigate = useNavigate();

  const { prefix } = useParams();
  console.log("prefix: "+  prefix );  
 

    const cookies = new Cookies();

  useEffect(() => {

    const stored_pat_cookie=cookies.get('points1smsssprivrw');
    console.log("stored_pat_cookie: "+  stored_pat_cookie );
  if ((prefix===undefined)&&(stored_pat_cookie===undefined))
  {
  alert("الرابط غير صحيح يرجى استخدام ال QR الذي أخذته من ال إدارة");

  }

  if (prefix!==undefined)
  {
     cookies.set('points1smsssprivrw', prefix, { path: '/' });

  }
  

  }, []);


   // cookies.set('points1smsssur', user, { path: '/' });
 
  /*
  var user_cookie= cookies.get('points1smsssur'); 
  var pass_cookie= cookies.get('points1smsssprivrw'); 
  */

  const [formData, setFormData] = useState({
    telegramCode: '',
    password: '',
    mobileNumber: ''
  });
  const [registerData, setRegisterData] = useState({
    fullName: '',
    email: '',
    phone: '',
    age: '',
    gender: '',
    password: '',
    confirmPassword: '',
    country:''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState(''); // ADDED: Success message state
  const [isRegistering, setIsRegistering] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleRegisterChange = (e) => {
    setRegisterData({
      ...registerData,
      [e.target.name]: e.target.value
    });
  };

  // ADDED: Create test Customer function
  const createTestCustomer = async () => {
    setIsLoading(true);
    setError('');
    setSuccessMessage('');

    try {
      const testCustomer = {
        name: 'أحمد محمد علي',
        email: 'test.Customer@example.com',
        password: 'test123',
        phone: '01098765432',
        age: 30,
        gender: 'male'
      };

      const response = await fetch(process.env.REACT_APP_API_BASE_URL+'/api/Customer/register', {
        method: 'POST',
        headers: {
                   'Content-Type': 'application/json',
          'Accept': 'application/json'  // Add this`
        },
        body: JSON.stringify(testCustomer),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage(`تم إنشاء العميل التجريبي بنجاح!     `);
        setFormData({
          telegramCode: data.telegram_code,
          mobileNumber: data.phone,
          password: data.password
        });
      } else {
        if (response.status === 400 && data.message.includes('مسجل بالفعل')) {
          setError('العميل التجريبي موجود بالفعل - جرب تسجيل الدخول بكلمة المرور: test123');
        } else {
          setError(data.message || 'حدث خطأ في إنشاء العميل التجريبي');
        }
      }
    } catch (err) {
      console.error('Error creating test Customer:', err);
      setError('حدث خطأ في الاتصال بالخادم');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setSuccessMessage(''); // ADDED: Clear success message

    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL+'/api/Customer/login', {  //  
        method: 'POST',
        headers: {
                   'Content-Type': 'application/json',
          'Accept': 'application/json'  // Add this`
        },
        body: JSON.stringify({
          mobileNumber: formData.mobileNumber,
          password: formData.password
        }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log('Login response data:', data); // ADDED: Debug logging
        // MODIFIED: Store TokenAs with correct keys
        localStorage.setItem('CustomerTokenA', data.tokenA); // CHANGED: Use CustomerTokenA instead of TokenA
        localStorage.setItem('CustomerData', JSON.stringify(data.customer)); // CHANGED: Store Customer data instead of separate fields
        
        localStorage.setItem('userType', 'Customer');

        // ⭐ NEW: Store entityId from URL prefix or cookie
        const entityId = prefix || cookies.get('points1smsssprivrw');
        if (entityId) {
          localStorage.setItem('customerEntityId', entityId);
          console.log('✅ Stored entityId in localStorage:', entityId);
        } else {
          console.warn('⚠️ No entityId found in URL or cookies');
        }

        // ADDED: Debug logging
        console.log('Customer login successful:', data.message);
        console.log('Customer data:', data.customer);
        console.log('Entity ID from URL/Cookie:', entityId);
        
        // Navigate to dashboard
        navigate('/Customer/dashboard');
      } else {
        setError(data.message || 'الكود أو كلمة المرور غير صحيحة');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('حدث خطأ في الاتصال بالخادم');
    } finally {
      setIsLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setSuccessMessage(''); // ADDED: Clear success message

    var country= document.getElementById('country').value;
    console.log("country: "+  country );

    if (registerData.country .indexOf('البلد')>=0 || registerData.country==='') {
      //setError('يرجى اختيار البلد');
      alert('يرجى اختيار البلد'); 
      //setIsLoading(false);
      return;
    }
   if ( country .indexOf('البلد')>=0 ) {
      //setError('يرجى اختيار البلد');
      alert('يرجى اختيار البلد'); 
      //setIsLoading(false);
      return;
    }
    
    if (registerData.country===undefined) {
    
     setRegisterData({
      ...registerData,
      [country]: country
    });
    }

    console.log('Register data:', registerData);
    // Validate passwords match
    if (registerData.password !== registerData.confirmPassword) {
      setError('كلمات المرور غير متطابقة');
      setIsLoading(false);
      return;
    }

    // Validate age
    if (registerData.age && (isNaN(registerData.age) || registerData.age < 1 || registerData.age > 120)) {
      setError('يرجى إدخال عمر صحيح');
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL+'/api/Customer/register', {
        method: 'POST',
        headers: {
                   'Content-Type': 'application/json',
          'Accept': 'application/json'  // Add this`
        },
        body: JSON.stringify({
          name: registerData.fullName,
          email: registerData.email,
          phone: registerData.phone,
          country: registerData.country ,
          age: registerData.age ? parseInt(registerData.age) : null,
          gender: registerData.gender || null,
          password: registerData.password
        }),
      });

      const data = await response.json();

      if (response.ok) {
        // MODIFIED: Use success message state instead of alert
        setSuccessMessage(`تم إنشاء حسابك بنجاح!  `);
        
        // ADDED: Auto-fill login form with the new telegram code
        setFormData({
          telegramCode: data.telegram_code,
          password: registerData.password,
          mobileNumber: registerData.phone
        });
        
        // Clear form and switch to login
        setRegisterData({
          fullName: '',
          email: '',
          phone: '',
          age: '',
          gender: '',
          password: '',
          confirmPassword: ''
        });
        setIsRegistering(false);
      } else {
        setError(data.message || 'حدث خطأ في إنشاء الحساب');
      }
    } catch (err) {
      console.error('Registration error:', err);
      setError('حدث خطأ في الاتصال بالخادم');
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setSuccessMessage(''); // ADDED: Clear success message

    if (!formData.mobileNumber) {
      setError('يرجى إدخال رقم الموبايل لإعادة تعيين كلمة المرور');
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL+'/api/Auth/cust-reset-password', {
        method: 'POST',
        headers: {
                   'Content-Type': 'application/json',
          'Accept': 'application/json'  // Add this`
        },
        body: JSON.stringify({
          mobileNumber: formData.mobileNumber
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage('تم إرسال رابط إعادة تعيين كلمة المرور إلى حساب التليجرام الخاص بك إذا كان مسجلاً لدينا.');
      } else {
        setError(data.message || 'حدث خطأ في إرسال رابط إعادة التعيين');
      }
    } catch (err) {
      console.error('Reset password error:', err);
      setError('حدث خطأ في الاتصال بالخادم');
    } finally {
      setIsLoading(false);
    }
  };

  const botUsername = 'Reservation_ASASM_A1Bot'; // Replace with your bot username
  const telegramBotUrl = `https://t.me/${botUsername}`;

  const handleOpenBot = () => {
    window.open(telegramBotUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 via-blue-600 to-teal-500 flex-center"> {/* REVERTED: Back to your original working class */}
      <div className="glass p-8 m-4 w-full max-w-md">
        <div className="text-center mb-8">
          <h1   style={{marginTop: '12px',marginBottom: '12px'}}  className="text-white text-3xl font-bold mb-2">
            {isRegistering ? 'تسجيل عميل جديد' : 'تسجيل دخول العملاء'}
          </h1>
          <p className="text-white opacity-80"style={{marginTop: '12px',marginBottom: '12px'}}>   
            {isRegistering ? 'أنشئ حسابك الجديد' : 'أدخل رقم الموبايل وكلمة المرور'}
          </p>
        </div>

        <form onSubmit={isRegistering ? handleRegister : handleSubmit} className="flex-column gap-4"> {/* REVERTED: Back to your original working class */}
          {isRegistering ? (
            <>
              <div>
                <label className="text-white block mb-2">الاسم الكامل</label>
                <input
                  type="text"
                  name="fullName"
                  value={registerData.fullName}
                  onChange={handleRegisterChange}
                  placeholder="أدخل اسمك الكامل"
                  className="input"
                  required
                />
              </div>
              
              <div>
                <label className="text-white block mb-2">البريد الإلكتروني</label>
                <input
                  type="email"
                  name="email"
                  value={registerData.email}
                  onChange={handleRegisterChange}
                  placeholder="أدخل بريدك الإلكتروني"
                  className="input"
                  required
                />
              </div>
              
              <div>
                <label className="text-white block mb-2">رقم الهاتف</label>
                <input
                  type="tel"
                  name="phone"
                  value={registerData.phone}
                  onChange={handleRegisterChange}
                  placeholder="أدخل رقم هاتفك"
                  className="input"
                  required
                />
              </div>
{/*   */}
                <div>
                  <label className="text-white block mb-2">البلد  </label>
                  <select
                    id='country'
                    name="country"
                    value={registerData.country}
                    onChange={handleRegisterChange}
                    onInput={handleRegisterChange}  // <-- catch autofill
                    className="input"
                  >
                    <option  style={{ backgroundColor: "#7060C0", color: "white" }} value="">اختر البلد</option>
                    <option  style={{ backgroundColor: "#7060C0", color: "white" }}  value="2">مصر(+20) </option>
                    <option  style={{ backgroundColor: "#7060C0", color: "white" }}  value="966">السعودية(+966) </option>
                  </select>
                </div>

{/*   */}

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-white block mb-2">العمر (اختياري)</label>
                  <input
                    type="number"
                    name="age"
                    value={registerData.age}
                    onChange={handleRegisterChange}
                    placeholder="العمر"
                    className="input"
                    min="1"
                    max="120"
                  />
                </div>
                
                <div>
                  <label className="text-white block mb-2">الجنس (اختياري)</label>
                  <select
                    name="gender"
                    value={registerData.gender}
                    onChange={handleRegisterChange}
                    className="input"
                  >
                    <option  style={{ backgroundColor: "#7060C0", color: "white" }} value="">اختر الجنس</option>
                    <option  style={{ backgroundColor: "#7060C0", color: "white" }}  value="male">ذكر</option>
                    <option  style={{ backgroundColor: "#7060C0", color: "white" }}  value="female">أنثى</option>
                  </select>
                </div>
              </div>
              
              <div>
                <label className="text-white block mb-2">كلمة المرور</label>
                <input
                  type="password"
                  name="password"
                  value={registerData.password}
                  onChange={handleRegisterChange}
                  placeholder="أدخل كلمة المرور"
                  className="input"
                  required
                />
              </div>
              
              <div>
                <label className="text-white block mb-2">تأكيد كلمة المرور</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={registerData.confirmPassword}
                  onChange={handleRegisterChange}
                  placeholder="أعد إدخال كلمة المرور"
                  className="input"
                  required
                />
              </div>
            </>
          ) : (
            <>
              <div>
                <label className="text-white block mb-2"> الموبايل  </label>
                <input
                  type="text"
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  placeholder="أدخل رقم الموبايل  "
                  style={{ marginTop: '12px' }}  
                  className="input"
                  required
                />
              </div>

              <div>
                <label className="text-white block mb-2">كلمة المرور</label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="أدخل كلمة المرور"
                   style={{ marginTop: '12px' }}  
                  className="input"
                  required
                />
              </div>
            </>
          )}

          {error && (
            <div className="bg-red-500 bg-opacity-20 border border-red-500 rounded-lg p-3">
              <p className="text-white text-sm">{error}</p>
            </div>
          )}

          {/* ADDED: Success message display */}
          {successMessage && (
            <div className="bg-green-500 bg-opacity-20 border border-green-500 rounded-lg p-3">
              <p className="text-white text-sm">{successMessage}</p>
            </div>
          )}

          <button
            type="submit"
            className="btn btn-primary w-full"
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="flex-center gap-2"> {/* REVERTED: Back to your original working class */}
                <div className="spinner"></div>
                <span>{isRegistering ? 'جاري إنشاء الحساب...' : 'جاري تسجيل الدخول...'}</span>
              </div>
            ) : (
              isRegistering ? 'إنشاء حساب' : 'تسجيل الدخول'
            )}
          </button>

     {! isRegistering && (     <button
            type="button"
            className="btn btn-primary w-full"
            disabled={isLoading}
            onClick={handleResetPassword}  // ADDED: Reset password handler
          >
            {isLoading ? (
              <div className="flex-center gap-2"> {/* REVERTED: Back to your original working class */}
                <div className="spinner"></div>
                <span>{isRegistering ? 'جاري إنشاء الحساب...' : 'جاري ارسال لينك على التيليجرام...'}</span>
              </div>
            ) : (
              isRegistering ? 'إنشاء حساب' : ' نسيت كلمة السر'
            )}
          </button> ) }


        </form>

        <div className="mt-6 text-center space-y-3"> {/* ADDED: space-y-3 for better spacing */}
          <p style={{ marginTop: '12px', marginBottom: '12px' }} className="text-white opacity-80 mb-2">
            {isRegistering ? 'لديك حساب بالفعل؟' : 'ليس لديك حساب؟'}
          </p>
          <button style={{marginTop: '12px',marginBottom: '12px'}}  
            className="btn btn-secondary w-full"  /* ADDED: w-full for consistent button width */ 
            onClick={() => {
              setIsRegistering(!isRegistering);
              setError(''); // ADDED: Clear error when switching
              setSuccessMessage(''); // ADDED: Clear success message when switching
            }}
          >
            {isRegistering ? 'تسجيل الدخول' : 'إنشاء حساب جديد'}
          </button>

          {/* ADDED: Test Customer creation button */}
          {/* <button 
            className="btn btn-secondary bg-green-600 hover:bg-green-700 w-full" 
            onClick={createTestCustomer}
            disabled={isLoading}
          >
            إنشاء عميل تجريبي (للاختبار)
          </button> */}

{/* 
          <button className="btn btn-secondary w-full" onClick={() => navigate('/')}> 
            العودة للصفحة الرئيسية
          </button> */}

        </div>

        <div className="mt-6 p-4 glass-dark rounded-lg center1">
          <h3 className="text-white font-semibold mb-2  center1 my-margin-top-1">فيديو للشرح   :</h3>
            <div style={{ 
              width: '300px', 
              margin: '0 auto',  // Centers the div horizontally
              aspectRatio: '9/16'  // Maintains video aspect ratio
            }}>
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/EnQ228gWArI"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ display: 'block' }}
              />
            </div>

          <h3 className="text-white font-semibold mb-2 center1 my-margin-top-1"> التيليجرام     :</h3>

          <button 
            onClick={handleOpenBot}
            style={{
              padding: '12px 24px',
              backgroundColor: '#0088cc',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '22px',
              fontWeight: 'bold'
            }}
          >
            اضغط للتواصل عبر التيليجرام
          </button>

        </div>

{/* ================== Footer ================== */}
<div 
  style={{
    marginTop: "30px",
    padding: "12px",
    textAlign: "center",
    color: "white",
    fontSize: "14px",
    opacity: 0.9,
    cursor: "pointer"
  }}
  onClick={() => {
    window.open("https://wa.me/201550834905", "_blank");
  }}
>
  تم التصميم بواسطة شركة التسنيم للبرمجيات
</div>
{/* =============================================== */}
        
      </div>
    </div>
  );
};

export default CustomerLogin;